// extracted by mini-css-extract-plugin
export default {"container":"styles_container__d6snB","title":"styles_title__NqOt3"};